var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { cloneDeep, uniqueId } from 'lodash';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Scrollbar } from 'element-ui';
import VueDraggableResizable from 'vue-draggable-resizable-gorkys';
import PrintConfigService from '@/api/PrintConfigService';
import 'vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css';
var qrcodePng = require('@/assets/images/qrcode.png');
var emptyNodeItem = {
    x_coordinates: 10,
    y_coordinates: 10,
    width: 200,
    height: 24,
    font_size: 12,
    is_bold: false,
    is_italic: false,
    print_type: 1
};
var DragTemplate = (function (_super) {
    __extends(DragTemplate, _super);
    function DragTemplate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeNode = {};
        _this.nodeList = _this.configModel.table_header_column || [];
        _this.groupList = [];
        _this.isNodeActive = false;
        _this.mm2px = 3.779527559;
        _this.maxWidth = 800;
        _this.maxHeight = 400;
        _this.formatList = [
            {
                label: 'yyyy年MM月dd日，如2018年07月12日',
                value: 'Y年m月d日',
            },
            {
                label: 'yyyy/MM/dd，如2018/07/12',
                value: 'Y/m/d',
            },
            {
                label: 'yyyy年MM月dd日 HH时mm分ss秒，如2018年07月12日 12点12分12秒',
                value: 'Y年m年d日 H时m分s秒'
            },
            {
                label: 'yyyy/MM/dd HH:mm:ss，如2018/07/12 10:24:56',
                value: 'Y/m/d H:m:s'
            }
        ];
        return _this;
    }
    DragTemplate.prototype.onValueChange = function (val) {
        console.log('onValueChange>>>', val);
        this.nodeList = val;
        this.initQrcodeDom();
    };
    DragTemplate.prototype.onWidthChange = function (val) {
        this.setParentBoundary();
    };
    DragTemplate.prototype.onHeightChange = function (val) {
        this.setParentBoundary();
    };
    DragTemplate.prototype.created = function () {
        this.mm2px = this.getOneMmsPx();
        console.log('mm2px>>>', this.mm2px);
        this.service = PrintConfigService.getInstance();
        this.initFieldList();
    };
    DragTemplate.prototype.onActivated = function (item) {
        if (this.readonly) {
            return;
        }
        item.label = item.label || item.name;
        this.activeNode = item;
        this.isNodeActive = true;
        console.log('onActivated>>>', item);
    };
    DragTemplate.prototype.onDeactivated = function () {
        this.isNodeActive = false;
        console.log('onDeactivated>>>');
    };
    DragTemplate.prototype.mounted = function () {
        var _this = this;
        document.addEventListener('keydown', function (e) {
            if (e.keyCode === 46 || e.keyCode === 8) {
                if (_this.isNodeActive)
                    _this.delNode();
            }
        });
        this.maxWidth = this.$refs.content.clientWidth;
        this.maxHeight = this.$refs.content.clientHeight - 55;
        this.initQrcodeDom();
    };
    DragTemplate.prototype.getOneMmsPx = function () {
        var div = document.createElement("div");
        div.id = "mm";
        div.style.width = "1mm";
        document.querySelector("body").appendChild(div);
        var mm1 = document.getElementById("mm").getBoundingClientRect();
        this.$emit('mm2px-change', mm1.width);
        return mm1.width;
    };
    DragTemplate.prototype.setParentBoundary = function () {
        var _this = this;
        setTimeout(function () {
            _this.$nextTick(function () {
                Object.keys(_this.$refs).forEach(function (key) {
                    if (key.startsWith('vueDraggableResizable')) {
                        Array.isArray(_this.$refs[key]) && _this.$refs[key].length && _this.$refs[key][0].checkParentSize();
                    }
                });
            });
        }, 100);
    };
    DragTemplate.prototype.initFieldList = function () {
        var _this = this;
        this.service.getSortTagFieldList(this.extraParam).then(function (res) {
            var _a = res.data, code = _a.code, data = _a.data;
            console.log('getSortTagFieldList>>>', res);
            if (code === 0) {
                _this.groupList = data;
            }
        });
    };
    DragTemplate.prototype.initQrcodeDom = function () {
        var _this = this;
        var qrcodeNode = this.nodeList.filter(function (item) { return item.type === 4; });
        if (!qrcodeNode.length)
            return;
        setTimeout(function () {
            _this.$nextTick(function () {
                qrcodeNode.forEach(function (item) {
                    var qrcodeImg = document.getElementById(item.id);
                    var previewQrcode = document.getElementById('preview-' + item.id);
                    if (previewQrcode) {
                        previewQrcode.innerHTML = "<img src=\"" + qrcodePng + "\" >";
                    }
                    if (qrcodeImg) {
                        qrcodeImg.innerHTML = "<img src=\"" + qrcodePng + "\" >";
                    }
                });
            });
        }, 50);
    };
    DragTemplate.prototype.addNode = function (item) {
        if (this.readonly) {
            return;
        }
        var nodeItem = __assign({}, cloneDeep(emptyNodeItem), item, { label: item.name + '：', id: uniqueId('node-' + this.nodeList.length + '-') });
        if (item.type === 4) {
            nodeItem.height = 80;
            nodeItem.width = 80;
            nodeItem.is_show_detail = 1;
        }
        else if (item.type === 2) {
            nodeItem.date_format = 'Y年m月d日';
            if (item.delay_input) {
                nodeItem.delay_value = item.delay_default_value || 0;
                nodeItem.delay_unit = item.delay_default_unit || 'day';
                nodeItem.delay_input = item.delay_input;
                nodeItem.delay_units = item.delay_units;
            }
        }
        if (item.key === 'customer_field') {
            nodeItem.type = 3;
        }
        this.nodeList.push(nodeItem);
        this.initQrcodeDom();
        this.$emit('input', this.nodeList);
    };
    DragTemplate.prototype.onDrag = function (x, y) {
        if (this.readonly) {
            return;
        }
        this.activeNode.x_coordinates = x;
        this.activeNode.y_coordinates = y;
    };
    DragTemplate.prototype.onDragStop = function () {
        if (this.readonly) {
            return;
        }
        this.$emit('input', this.nodeList);
    };
    DragTemplate.prototype.delNode = function () {
        var _this = this;
        if (!this.activeNode.id) {
            return;
        }
        var index = this.nodeList.findIndex(function (item) { return item.id === _this.activeNode.id; });
        this.nodeList.splice(index, 1);
        console.log('delNode>>>', index, this.activeNode);
        this.activeNode = {};
        this.isNodeActive = false;
    };
    DragTemplate.prototype.getItemStyle = function (item) {
        var mm2px = this.mm2px;
        return {
            'font-weight': item.is_bold == 1 ? 'bold' : 'normal',
            'text-decoration': item.is_italic == 1 ? 'underline' : 'none',
            'font-size': item.font_size + 'px',
            'line-height': item.font_size + 'px'
        };
    };
    __decorate([
        Prop({
            type: Array
        })
    ], DragTemplate.prototype, "fontSizeList", void 0);
    __decorate([
        Prop({
            type: Object
        })
    ], DragTemplate.prototype, "configModel", void 0);
    __decorate([
        Prop({
            type: Array
        })
    ], DragTemplate.prototype, "value", void 0);
    __decorate([
        Prop({
            type: Object,
            default: {}
        })
    ], DragTemplate.prototype, "extraParam", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], DragTemplate.prototype, "readonly", void 0);
    __decorate([
        Watch('value', { immediate: true, deep: true })
    ], DragTemplate.prototype, "onValueChange", null);
    __decorate([
        Watch('configModel.print_width', { immediate: true, deep: true })
    ], DragTemplate.prototype, "onWidthChange", null);
    __decorate([
        Watch('configModel.print_height', { immediate: true, deep: true })
    ], DragTemplate.prototype, "onHeightChange", null);
    DragTemplate = __decorate([
        Component({
            components: {
                VueDraggableResizable: VueDraggableResizable,
                Scrollbar: Scrollbar
            },
            computed: {
                paperStyle: function () {
                    var _a = this.configModel, print_width = _a.print_width, print_height = _a.print_height;
                    var width = print_width;
                    var height = print_height;
                    var ratio = width / height;
                    var base_width = window.outerWidth > 1440 ? 160 : 120;
                    var zoom = base_width / width;
                    return {
                        width: width + 'mm',
                        height: height + 'mm',
                        zoom: zoom
                    };
                }
            }
        })
    ], DragTemplate);
    return DragTemplate;
}(Vue));
export default DragTemplate;
